import React, { useState } from "react";
import Alert from "../../../controls/Alert";
import __ from "lodash";
import moment from "moment";

const AddSlotValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";
  let id = null;
  const slotTypes = [{"code":"TURNROUND","value":"Turnround"},{"code":"NON_TURNROUND","value":"Non-Turnround"}];
  let slotType = __.find(slotTypes, {value: record.slotType});
  if (!slotType)
    slotType = {};

  const nothingChanged = () => {
    if (!__.has(record, "parentRecord"))
      return false;
    const oldRecord = {...record.parentRecord, slotUuid: undefined, slotActionCode: undefined, parentRecord: undefined};
    const currentRecord = {...record, slotUuid: undefined, slotActionCode: undefined, parentRecord: undefined}
    return __.isEqual(oldRecord, currentRecord);
  }

  const checkFromDate = (slotFrom, slotTo, label) => {
    if (slotFrom.isBefore(moment(Date()).startOf('day')))
      return {invalid: true, error: `'${label}' must match a future slot operating day`};

    const checkDays = label && label.startsWith("Change") ? record.changeDays : record.days;
    if (checkDays) {
      const days = checkDays.split("");
      const numberOfDays = slotTo.diff(slotFrom, 'days') + 1;
      const searchDate = moment(slotFrom);
      const nextOperatingDates = [];
      for (let i=0; i<numberOfDays; i++) {
        if (days.includes(searchDate.isoWeekday().toString())) {
          if (searchDate.isSame(slotFrom)) {
            return {invalid: false, error: ""};
          }
          nextOperatingDates.push(moment(searchDate));
        }
        searchDate.add(1, 'day');
      }
      let nextOperatingDay = "";
      if (nextOperatingDates.length > 0) {
        nextOperatingDay = ` (next operating day is ${nextOperatingDates[0].format("DD/MM/YYYY")})`
      } else {
        nextOperatingDay = ` (no slot available between the specified dates ${slotFrom.format("DD/MM/YYYY")} to ${slotTo.format("DD/MM/YYYY")})`
      }
      return {invalid: true, error: `'${label}' must match a valid future slot operating day${nextOperatingDay}`};
    }

    return {invalid: false, error: ""};
  }

  const checkToDate = (slotFrom, slotTo, label) => {
    if (slotTo.isBefore(moment(Date()).startOf('day')))
      return {invalid: true, error: `'${label}' must match a valid future slot operating day`};

    const checkDays = label && label.startsWith("Change") ? record.changeDays : record.days;
    if (checkDays) {
      const days = checkDays.split("");
      const numberOfDays = slotTo.diff(slotFrom, 'days') + 1;
      const searchDate = moment(slotTo);
      const nextOperatingDates = [];
      for (let i=0; i<numberOfDays; i++) {
        if (days.includes(searchDate.isoWeekday().toString())) {
          if (searchDate.isSame(slotTo)) {
            return {invalid: false, error: ""};
          }
          nextOperatingDates.push(moment(searchDate));
        }
        searchDate.add(-1, 'day');
      }
      let nextOperatingDay = "";
      if (nextOperatingDates.length > 0) {
        nextOperatingDay = ` (latest operating day is ${nextOperatingDates[0].format("DD/MM/YYYY")})`
      } else {
        nextOperatingDay = ` (no slot available between the specified dates ${slotFrom.format("DD/MM/YYYY")} to ${slotTo.format("DD/MM/YYYY")})`
      }
      return {invalid: true, error: `'${label}' must match a valid future slot operating day${nextOperatingDay}`};
    }

    return {invalid: false, error: ""};
  }

  if (!error && !record.airportCode ) {
    error = true;
    errorMessage = "'Slot at Airport' is required";
    id = "airportCode";
  }
  if (!error && record.newSlotMode && !record.slotType ) {
    error = true;
    errorMessage = "Please select the required 'Slot Type'";
    id = "slotType";
  }
  if (!error && !record.slotActionCode ) {
    error = true;
    errorMessage = "Please select the required 'Slot Request'";
    id = "slotActionCode";
  }
  if (!error && !record.slotPeriodFrom ) {
    error = true;
    const label = ["C", "M"].includes(record.slotActionCode) ? "Reference From" : "Slot Period From";
    errorMessage = `'${label}' is required`;
    id = "slotPeriodFrom";
  }
  if (!error && !record.slotPeriodTo ) {
    error = true;
    const label = ["C", "M"].includes(record.slotActionCode) ? "Reference To" : "Slot Period To";
    errorMessage = `'${label}' is required`;
    id = "slotPeriodTo";
  }
  const slotFrom = moment(record.slotPeriodFrom);
  const slotTo = moment(record.slotPeriodTo);
  let operatingDay = checkFromDate(slotFrom, slotTo, ["C", "M"].includes(record.slotActionCode) ? "Reference From" : "Slot Period From");
  if (!error && operatingDay.invalid) {
    error = true;
    errorMessage = operatingDay.error;
    id = "slotPeriodFrom";
  }
  if (!error && slotTo.isBefore(slotFrom)) {
    error = true;
    const fromLabel = ["C", "M"].includes(record.slotActionCode) ? "Reference To" : "Slot Period To";
    const toLabel = ["C", "M"].includes(record.slotActionCode) ? "Reference To" : "Slot Period To";
    errorMessage = `'${toLabel}' must be after or equal to '${fromLabel}'`;
    id = "slotPeriodTo";
  }
  let validSlotPeriod = false;
  if (record.slotRequirements && !__.isEmpty(record.slotRequirements) && Array.isArray(record.slotRequirements)) {
    for (let i = 0; i < record.slotRequirements.length; i++) {
      const slotInfo = record.slotRequirements[i];
      const seasonStart = moment(slotInfo.seasonsStarts, "YYYY-MM-DD");
      const seasonEnd = moment(slotInfo.seasonsEnds, "YYYY-MM-DD");
      if (slotFrom.isBetween(seasonStart, seasonEnd, undefined, '[]') && slotTo.isBetween(seasonStart, seasonEnd, undefined, "[]")) {
        validSlotPeriod = true;
        break;
      }
    }
  }
  if (!error && !validSlotPeriod) {
    error = true;
    errorMessage = `Slot period is not within an active season for ${record.airportCode}`;
    id = "slotPeriodFrom";
  }

  operatingDay = checkToDate(slotFrom, slotTo, ["C", "M"].includes(record.slotActionCode) ? "Reference To" : "Slot Period To");
  if (!error && operatingDay.invalid) {
    error = true;
    errorMessage = operatingDay.error;
    id = "slotPeriodTo";
  }
  if (["C", "M"].includes(record.slotActionCode)) {
    if (!error && !record.slotChangePeriodFrom ) {
      error = true;
      errorMessage = `'Change From' is required`;
      id = "slotChangePeriodFrom";
    }
    if (!error && !record.slotChangePeriodTo ) {
      error = true;
      errorMessage = `'Change To' is required`;
      id = "slotChangePeriodTo";
    }
    const slotFrom = moment(record.slotChangePeriodFrom);
    const slotTo = moment(record.slotChangePeriodTo);
    let operatingDay = checkFromDate(slotFrom, slotTo, "Change From");
    if (!error && operatingDay.invalid) {
      error = true;
      errorMessage = operatingDay.error;
      id = "slotChangePeriodFrom";
    }
    if (!error && slotTo.isBefore(slotFrom)) {
      error = true;
      errorMessage = `'Change To' must be after or equal to 'Change From'`;
      id = "slotChangePeriodTo";
    }
    operatingDay = checkToDate(slotFrom, slotTo, "Change To");
    if (!error && operatingDay.invalid) {
      error = true;
      errorMessage = operatingDay.error;
      id = "slotChangePeriodTo";
    }
  }
  if (!error && (!record.arrivalAirlineCode || !record.arrivalFlightNo)) {
    error = true;
    errorMessage = "'Inbound Flight' is required";
    id = "arrivalAirlineCode";
  }
  if (!error && (!record.departureAirlineCode || !record.departureFlightNo)) {
    error = true;
    errorMessage = "'Outbound Flight' is required";
    id = "departureAirlineCode";
  }
  if (!error && !record.originAirportCode ) {
    error = true;
    errorMessage = "'Origin Airport' is required";
    id = "originAirportCode";
  }
  if (!error && !record.arrivalTime ) {
    error = true;
    errorMessage = "'Arrival Time' is required";
    id = "arrivalTime";
  }
  if (!error && !record.departureTime ) {
    error = true;
    errorMessage = "'Departure Time' is required";
    id = "departureTime";
  }
  if (!error && !record.destinationAirportCode ) {
    error = true;
    errorMessage = "'Destination Airport' is required";
    id = "destinationAirportCode";
  }
  if (!error && ["C", "M"].includes(record.slotActionCode) && nothingChanged())
  {
    error = true;
    errorMessage = "At least one value should be changed when requesting a Slot change";
    id = null;
  }


  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );

}

export default AddSlotValidator;
